import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export { default as Button } from "./Button.vue"

export const buttonVariants = cva(
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
    {
        variants: {
            variant: {
                default:
                    'bg-primary text-primary-foreground shadow-xs hover:bg-primary/90 transition-colors',
                destructive:
                    'bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60 transition-colors',
                'destructive-outline':
                    'border border-destructive bg-transparent text-destructive hover:bg-destructive/10 dark:hover:bg-destructive/20 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 transition-colors',
                success:
                    'bg-green-500 text-white shadow-xs hover:bg-green-600 focus-visible:ring-green-500/20 dark:focus-visible:ring-green-500/40 dark:bg-green-500/60 transition-colors',
                'success-outline':
                    'border-2 border-green-500 bg-transparent text-green-600 dark:text-green-400 hover:bg-green-500/10 dark:hover:bg-green-500/20 focus-visible:ring-green-500/20 dark:focus-visible:ring-green-500/40 transition-colors',
                info:
                    'bg-blue-500 text-white shadow-xs hover:bg-blue-600 focus-visible:ring-blue-500/20 dark:focus-visible:ring-blue-500/40 dark:bg-blue-500/60 transition-colors',
                'info-outline':
                    'border-2 border-blue-500 bg-transparent text-blue-600 dark:text-blue-400 hover:bg-blue-500/10 dark:hover:bg-blue-500/20 focus-visible:ring-blue-500/20 dark:focus-visible:ring-blue-500/40 transition-colors',
                warning:
                    'bg-yellow-500 text-black shadow-xs hover:bg-yellow-600 focus-visible:ring-yellow-400/20 dark:focus-visible:ring-yellow-400/40 dark:bg-yellow-500/80 transition-colors',
                'warning-outline':
                    'border-2 border-yellow-500 bg-transparent text-yellow-600 dark:text-yellow-400 hover:bg-yellow-500/10 dark:hover:bg-yellow-500/20 focus-visible:ring-yellow-400/20 dark:focus-visible:ring-yellow-400/40 transition-colors',
                neutral:
                    'bg-gray-400 text-white shadow-xs hover:bg-gray-500 focus-visible:ring-gray-400/20 dark:focus-visible:ring-gray-400/40 dark:bg-gray-400/60 transition-colors',
                'neutral-outline':
                    'border-2 border-gray-400 bg-transparent text-gray-600 dark:text-gray-400 hover:bg-gray-400/10 dark:hover:bg-gray-400/20 focus-visible:ring-gray-400/20 dark:focus-visible:ring-gray-400/40 transition-colors',
                outline:
                    'border-2 border-border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-border dark:hover:bg-input/50 transition-colors',
                secondary:
                    'bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80',
                ghost:
                    'hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50',
                link: 'text-primary underline-offset-4 hover:underline',
                'input-outline': 'border border-border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-border dark:hover:bg-input/50 transition-colors',
            },
            size: {
                default: "h-9 px-4 py-2 has-[>svg]:px-3",
                sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
                lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
                icon: "size-9",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
